export const bvConfig = {
  BButton: { size: "sm" },
  BFormInput: { size: "sm" },
  BFormSelect: { size: "sm" },
  BFormTextarea: { size: "sm" },
  BDropdown: { size: "sm" },
  BInputGroup: { size: "sm" },
  BPagination: { size: "sm" },
  BTable: { striped: true },
};
